export default __webpack_public_path__ + "static/media/wowza.6504952c.png";